<template>
    <search-select v-bind="$attrs" :options="options" :allow-empty="allowEmpty" :searchable="true" label="identity" placeholder="Выберите модем" v-on="listeners" @input="$emit('input', $event)">
        <template slot="option" slot-scope="scope">
            <div class="d-flex align-items-center flex-truncate">
                <div class="text-truncate">{{ scope.option.identity }}</div>
            </div>
        </template>

        <template slot="singleLabel" slot-scope="scope">
            <div class="d-flex align-items-center flex-truncate">
                <div class="text-truncate">{{ scope.option.identity }}</div>
            </div>
        </template>
    </search-select>
</template>

<script>
import SearchSelect from '@/components/Select'

export default {
    components: {
        SearchSelect
    },

    inheritAttrs: false,

    props: {
        allowEmpty: {
            type: Boolean,
            default: true
        },

        options: {
            type: Array,
            default: _ => []
        }
    },

    computed: {
        listeners() {
            const { input, ...listeners } = this.$listeners
            return listeners
        }
    }
}
</script>
